import { Component, OnInit, ViewChild } from '@angular/core';
import { EmailEditorComponent } from 'angular-email-editor';
import { MessageService, SelectItem } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import {  ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-campaign-edit',
  templateUrl: './campaign-edit.component.html',
  styleUrls: ['./campaign-edit.component.css'],
  providers: [ MessageService]
})

export class CampaignEditComponent implements OnInit {
    @ViewChild(EmailEditorComponent) private emailEditor: EmailEditorComponent;
    statusList:SelectItem[] = [];
    emailfromList:SelectItem[] = [];
    surveysList:SelectItem[] = [];
    projectId:191515;
    duplicatename='';
    action="new";
    showDialogDuplicate:boolean=false;
    editorready=false;
 
    email:any={};
    options={
      appearance: {
        theme: 'dark',
      },

      
    };
    

    constructor(
      private apiService: ApiService,
      private messageService: MessageService,
      private router: Router,
      private route: ActivatedRoute
    ) { }
  
    ngOnInit(): void {


      this.apiService.get('surveys/smtp',{}).subscribe(data => {
        data.Result.forEach((r)=>{
          this.emailfromList.push({label:r.from_name,value:r.from_name});
        });
        this.email.email_from=this.emailfromList[0].value;
      });
      if (this.route.snapshot.paramMap.get('id')) {
        this.action=this.route.snapshot.paramMap.get('id');
      }
      this.statusList.push({label:'DRAFT',value:'DRAFT'});
      this.statusList.push({label:'TO CONFIRM',value:'TO CONFIRM'});
      this.email.status=this.statusList[0].value;
      this.email.id_survey=this.surveysList[0];
      this.apiService.get('surveys/listall',{}).subscribe(data => {
        this.surveysList=data.Result;
        if( this.surveysList.length>0){
          this.email.id_survey=this.surveysList[0]['id'];
          if (this.route.snapshot.paramMap.get('id')) {
           
            this.apiService.get('surveys/emaillistall',{}).subscribe(data => {
              for (const g of data.Result) {
                if(g['id']==parseInt(this.route.snapshot.paramMap.get('id'))){
                  this.email=g;
                  if(this.email['status']=='TO CONFIRM'){
                    this.email['to_send']=1;
                  } 
               
                  if(this.email.id_survey){
              
                    for (const r of this.surveysList) {
                      if(r['id']==this.email.id_survey){
                     //   this.email.id_survey=r;
                      }
                    }
                  }
                }
              }
            });
          }
        }
        });
      
    }
  
    addSingle(sev: string, sum: string, det: string) {
      this.messageService.add({severity: sev, summary: sum, detail: det});
    }
  
   
  // called when the editor is created
  editorLoaded() {
  
  }

  // called when the editor has finished loading
  editorReady() {
  
  
    if(!this.email.text){
      
        this.email.text={};
        this.emailEditor.loadDesign({});
      } else{
        
      

        this.emailEditor.loadDesign(JSON.parse(this.email.text));
      }
     this.emailEditor.editor.showPreview("desktop");
     this.editorready=true;
    
   
    let mergeTags:any={};
    mergeTags={
      first_name: {
        name: "First Name",
        value: "{{first_name}}",
      },
      last_name: {
        name: "Last Name",
        value: "{{last_name}}",
      }
    }
    this.emailEditor.editor.setMergeTags(mergeTags);

  }

  private validate() : boolean {
    let isValid : boolean = true;
   
    if (this.email.name=='') {
      this.addSingle('error', 'Error', 'Field name is mandatory');
        isValid = false;
    }

    

    
    if (this.email.email_from=='') {
      this.addSingle('error', 'Error', 'Field from is mandatory');
        isValid = false;
    }

  
    
    return isValid;
  }


  save() {
    if (this.validate()) {

      if((this.action=='duplica')&&(this.duplicatename=='')){
        return;
      }
      if(this.action=='duplica'){
        delete this.email['id'];
        this.email['name']=this.duplicatename;
      }

      this.emailEditor.editor.exportHtml(data => {
        this.email.text=JSON.stringify(data.design);
        this.email.html=data.html;

        this.apiService.updateEmail(this.email).subscribe(data => {
          this.addSingle('success', 'Successo', 'Email Updated');
          });
      });
    }
  }

  duplicate(){
    this.showDialogDuplicate=true;
  }

  saveduplica(){
    this.showDialogDuplicate=false;
    this.action='duplica';
    this.save()
  }

  }
  